<template>
  <div class="vuw-bg-support-5">
    <div
        class="grid-x align-middle align-justify vuw-p-3 vuw-p-m-6 vuw-pl-m-4 vuw-pr-m-4 vuw-p-xl-6 vuw-bg-third-1 vuw-text-support-5 vuw-award-title-bar">
      <div class="cell auto">
        <p class="vuw-h2-light">{{ selectedCategory.name }}</p>
      </div>
      <div class="cell shrink vuw-right vuw-award-result vuw-align-center">
        <span class="vuw-medium">{{ selectedCategory.numberOfAwards }}x</span>
        <i class="fal fa-medal vuw-ml-2 vuw-mb-2 vuw-bold vuw-text-xxl"></i>
      </div>
    </div>
    <div class="vuw-ph-4 vuw-pv-3 vuw-p-m-4 vuw-p-l-6 vuw-light">
      <rich-text-atom
          ref="contentElement"
          :paragraphs="[selectedCategory.description]"
          v-scroll-directive="'scrolled'">
      </rich-text-atom>
    </div>
  </div>
</template>

<script>
import {defineComponent} from "@vue/composition-api";
import {useState} from "vuex-composition-helpers";
import RichTextAtom from "@/shared/components/atoms/RichTextAtom";
import scrollDirective from "@/shared/directives/scroll-directive";

export default defineComponent({
  name: "AwardInfoComponent",
  components: {
    RichTextAtom
  },
  directives: {
    scrollDirective
  },
  setup: () => {
    const {selectedCategory} = useState(['selectedCategory'])

    return {
      selectedCategory
    }
  }
})
</script>
